
export default {
  staticDomain: '//static.hsappstatic.net' || window.location.host,
  staticDomainPrefix: '//static.hsappstatic.net' || ('//' + window.location.host),
  currentProject: 'marketplace-storefront-public-ui',
  currentProjectVersion: 'static-1.11658',
  depVersions: {
  "marketplace-storefront-public-ui": "static-1.11658",
  "apollo-dlb": "static-3.80",
  "client-types": "static-1.450",
  "dashboard-client-types": "static-1.254",
  "data-fetching-client": "static-1.9510",
  "foundations-components": "static-1-jhardy-popover-allow-cross-axis-shift.11",
  "foundations-components-legacy": "static-1-jhardy-popover-allow-cross-axis-shift.11",
  "foundations-theming": "static-1.4243",
  "googlemaps-react-wrapper": "static-1.3",
  "graphql": "static-1.78",
  "head-dlb": "static-1.4841",
  "hs-test-utils": "static-1.7838",
  "hub-http-shared-msw-handlers": "static-1.9553",
  "hubspot-dlb": "static-2.1806",
  "hubspot-url-utils": "static-1.3957",
  "HubStyleTokens": "static-2.11273",
  "I18n": "static-7.1580",
  "jasmine-runner": "static-1.6303",
  "marketplace-storefront-base": "static-1.11718",
  "quartz": "static-1.6776",
  "react-dlb": "static-1.73",
  "react-rhumb": "static-1.16483",
  "react-router-dom": "static-5.26",
  "reactive-variable-buffer-atom": "static-1.2696",
  "reporting-testing-lib": "static-1.8595",
  "settings-ui-lib": "static-1.12356",
  "SharedI18nStrings": "static-1.180",
  "signup-ui-core": "static-1.10391",
  "source-map": "static-1.4",
  "trellis-ecosystem": "static-1.6794",
  "ui-addon-i18n": "static-1.10977",
  "ui-addon-react-router-dom": "static-1.9378",
  "unified-auth": "static-1.260",
  "unified-auth-core-lib": "static-1.541",
  "usage-tracker": "static-1.7168",
  "usage-tracker-core": "static-1.7018",
  "customer-data-property-utils": "static-1.7912",
  "history": "static-4.47",
  "hub-http": "static-1.6051",
  "integrations-lib": "static-1.15535",
  "marketplace-ui-common": "static-1.19043",
  "property-management-iframe": "static-1.12468",
  "quartz-config": "static-1.554",
  "quartz-core": "static-1.5995",
  "quartz-routing": "static-1.206",
  "quick-fetch": "static-1.3769",
  "react": "static-7.180",
  "rpc-client-utils": "static-1.4468",
  "ts-schema": "static-1.3937",
  "ui-universal-auth": "static-1.8746",
  "UIComponents": "static-3.8220",
  "apollo-stack-hubspot": "static-3.79",
  "enviro": "static-4.405",
  "hs-promise-rejection-tracking": "static-1.5387",
  "PortalIdParser": "static-2.367",
  "raven": "static-3.5725",
  "raven-hubspot": "static-1.6032",
  "classnames": "static-2.10",
  "hoist-non-react-statics": "static-3.9",
  "immutable": "static-2.19",
  "metrics-js": "static-1.9436",
  "react-redux": "static-7.67",
  "redux": "static-4.16",
  "styled-components": "static-2.85",
  "bend-plugin-trellis-migration": "static-1.3260",
  "moment": "static-3.26",
  "react-dom": "static-7.85",
  "bend-plugin-quartz": "static-1.3053",
  "quartz-webpack": "static-1.3000",
  "fast-json-stable-stringify": "static-1.4",
  "bend-plugin-foundations-components": "static-1-jhardy-popover-allow-cross-axis-shift.11",
  "floating-ui": "static-1.52",
  "foundations-assets": "static-1.4670",
  "foundations-theming-specialty": "static-1.1959",
  "framer-motion": "static-1.68",
  "hs-story-utils": "static-1.9259",
  "react-aria": "static-1.62",
  "react-select-plus": "static-1.65",
  "react-utils": "static-2.5206",
  "react-virtualized": "static-2.95",
  "StyleGuideUI": "static-3.484",
  "tanstack-table": "static-1.51",
  "trellis-assets": "static-1.1304",
  "ui-fonts": "static-1.535",
  "ui-images": "static-2.1105",
  "bend-plugin-foundations-theming": "static-1.2726",
  "foundations-theming-base": "static-1.3228",
  "stylex": "static-1.28",
  "HeadJS": "static-2.718",
  "hs-test-utils-bend-plugin": "static-1.2949",
  "msw": "static-1.39",
  "testing-library": "static-1.148",
  "webpack-env": "static-1.54",
  "i18n-data": "static-1.217",
  "moment-timezone": "static-5.79",
  "jasmine": "static-4.4159",
  "ai-components-ui-library": "static-1.8440",
  "ai-rendering-library": "static-1.9403",
  "chirp-fetch": "static-1.1714",
  "connections-embed-lib": "static-1.685",
  "copilot-toolkit": "static-1.10617",
  "laboratory-lib": "static-3.6992",
  "marketplace-embed": "static-1.21560",
  "marketplace-ui-details": "static-1.8939",
  "marketplace-ui-reviews": "static-1.18999",
  "marketplace-ui-tracking": "static-1.13214",
  "sanitize-text": "static-1.7978",
  "ui-addon-video-player": "static-1.8529",
  "usage-tracker-multi": "static-1.5582",
  "usage-tracker-session-replay": "static-1.4854",
  "wootric-nps": "static-1.6817",
  "apollo-link-hub-http": "static-2.4484",
  "immer": "static-1.33",
  "immerable": "static-1.3987",
  "highcharts": "static-8.100",
  "hs-lodash": "static-4.45",
  "reporting-client-types": "static-1.2387",
  "reporting-data": "static-1.66662",
  "cssUtils": "static-1.744",
  "flux-actions": "static-1.311",
  "HubStyle": "static-2.11581",
  "PatternValidationJS": "static-1.437",
  "react-colorpicker": "static-2.10044",
  "react-dnd": "static-5.6",
  "react-dnd-html5-backend": "static-5.6",
  "redux-observable": "static-1.11",
  "ReduxMessenger": "static-2.10206",
  "rxjs": "static-5.10",
  "underscore": "static-1.8",
  "usage-tracker-container": "static-1.7158",
  "icons": "static-2.625",
  "marketplace-ui-apps-core": "static-1.17576",
  "storybook-react": "static-1.29",
  "trellis-story-utils": "static-1.4353",
  "foundations-components-test-utils": "static-1-jhardy-popover-allow-cross-axis-shift.11",
  "quartz-i18n": "static-1.451",
  "react-input-autosize": "static-2.17",
  "fsm": "static-1.3563",
  "customer-data-objects": "static-1.7480",
  "property-translator": "static-1.5242",
  "frontend-preferences-client": "static-1.7757",
  "hs-promise-utils": "static-1.5426",
  "hubspot-apollo-client": "static-1.4712",
  "integrations-error-boundary-lib": "static-1.12950",
  "integrations-tracking-lib": "static-1.5421",
  "native-integrations-shared-strings": "static-1.7620",
  "reselect": "static-2.16",
  "sanitize": "static-1.4307",
  "superstore": "static-1.4603",
  "ui-shepherd-react": "static-3.9979",
  "ai-settings-ui-library": "static-1.7550",
  "hub-http-janus": "static-1.803",
  "hubspotter-http": "static-1.4510",
  "immutable-less": "static-1.4487",
  "marketplace-ui-client-types": "static-1.16450",
  "nav-meta": "static-1.29020",
  "react-window": "static-1.13",
  "self-service-api": "static-1.10073",
  "ui-addon-upgrades": "static-9.17702",
  "inbound-db-properties-service-client": "static-1.3705",
  "property-management-common": "static-1.4755",
  "ui-addon-iframeable": "static-1.8879",
  "dispatcher": "static-1.132",
  "general-store": "static-6.20",
  "mobile-manifest-mixins": "static-1.491",
  "module-federation": "static-1.19",
  "quartz-auth": "static-1.451",
  "quartz-head": "static-1.441",
  "quartz-test": "static-1.451",
  "quartz-tracking": "static-1.155",
  "csstype": "static-1.50",
  "bender-build-tools": "static-1.2982",
  "autolinker": "static-3.11",
  "chatspot-core": "static-1.20470",
  "ContentUtils": "static-1.67719",
  "sassPrefix": "static-1.152",
  "avatar-components": "static-1.2322",
  "customer-data-filters-ui": "static-1.39023",
  "customer-data-objects-ui-components": "static-1.12843",
  "customer-data-reference-ui-components": "static-1.12979",
  "embedded-academy-lib": "static-1.13662",
  "ExportDialog": "static-6.10220",
  "highlight.js": "static-1.75",
  "markdown-it": "static-1.6",
  "reporting-action-components": "static-1.40739",
  "reporting-snowflake": "static-1.55280",
  "reporting-ui-components": "static-2.63933",
  "reporting-visualizations": "static-1.58738",
  "ui-addon-teams": "static-1.21283",
  "magpie-lib": "static-1.5426",
  "magpie-types": "static-1.4886",
  "simple-logging-lib": "static-1.2883",
  "navigation-components": "static-1.17383",
  "ai-studio-lib": "static-1.11088",
  "developer-experience-shared-components": "static-1.10325",
  "transmute": "static-2.85",
  "ui-addon-integrations-directory-panel": "static-2.7824",
  "ui-tool-access": "static-1.9977",
  "usage-based-billing-components-lib": "static-1.8097",
  "usage-tracker-anonymous": "static-1.5585",
  "usage-tracker-public": "static-1.6979",
  "amplitude-session-replay-browser": "static-1.56",
  "inbound-db-meta-service-client": "static-1.3452",
  "persist-promise": "static-1.3540",
  "reference-resolvers": "static-1.7995",
  "ui-extensibility-client-types": "static-1.3776",
  "hubspot-apollo-cache": "static-1.171",
  "universal-page-editor-lib": "static-1.2831",
  "redux-toolkit": "static-1.7",
  "simple-data-table": "static-1.2275",
  "merchandise-lib": "static-1.260",
  "atom": "static-1.4902",
  "purchase-motions-components": "static-1.5523",
  "salesImages": "static-1.521",
  "batch-promise": "static-1.1383",
  "crm-component-utils": "static-1.38560",
  "crm-properties-common-lib": "static-1.5705",
  "customer-data-properties": "static-1.50864",
  "framework-data-schema-resolvers": "static-1.6704",
  "reference-resolvers-lite": "static-1.7923",
  "navigation-messaging": "static-1.6710",
  "hubspotter-http-shared-msw-handlers": "static-1.9551",
  "cms-field-types": "static-1.4640",
  "content-icons-ui": "static-1.2167",
  "conversations-skeleton-state": "static-1.7081",
  "crm-message-bus": "static-1.42466",
  "customer-data-filters-ui-msw-helpers": "static-1.21458",
  "customer-data-ui-utilities": "static-1.9657",
  "FormUrlGenerator": "static-2.4557",
  "framework-builder-read-service-client": "static-1.3864",
  "framework-data-schema-quick-fetch": "static-1.6609",
  "multi-account-reference-resolvers": "static-1.806",
  "onboarding-tours": "static-1.16309",
  "react-immutable-proptypes": "static-2.8",
  "reporting-datasets-permissions-lib": "static-1.13158",
  "academy-common-lib": "static-1.13122",
  "content-assistance-lib": "static-1.7496",
  "dashboard-lib": "static-1.80763",
  "file-manager-components": "static-1.22996",
  "getting-started-shared-tasks": "static-1.17978",
  "hubspot-prosemirror": "static-1.17695",
  "hubspot-prosemirror-plugins": "static-1.17687",
  "prosemirror": "static-1.13",
  "rich-text-lib": "static-1.19527",
  "share-with-third-party-component-lib": "static-1.8526",
  "ui-addon-draggable": "static-3.4599",
  "ui-asset-management-lib": "static-1.10751",
  "ui-business-units-lib": "static-1.8861",
  "user-context": "static-1.4932",
  "growth-payments-core": "static-1.24823",
  "reporting-plugins": "static-1.10022",
  "reporting-reports": "static-1.66340",
  "idb-keyval": "static-1.40",
  "reactive-lib": "static-1.558",
  "codemirror": "static-5.91",
  "feedback-loader": "static-1.28928",
  "react-codemirror": "static-1.10459",
  "apps-service-types": "static-1.3709",
  "oauth-service-types": "static-1.4080",
  "onboarding-scopes": "static-1.6296",
  "onboarding-tours-client": "static-1.4523",
  "platform-infra-nav-components": "static-1.7523",
  "subscription-experience-data-types": "static-1.14623",
  "crm-record-cards-service-types": "static-1.3475",
  "location-customization-utils-lib": "static-1.8667",
  "redux-thunk": "static-2.43",
  "growth-monetization-service-types": "static-1.4332",
  "nav-client-types": "static-1.2189",
  "purchase-motions-api": "static-1.5526",
  "signup-constants": "static-1.18489",
  "signup-ui-url-generator": "static-2.7867",
  "trials-service-types": "static-1.3733",
  "card-properties-lib": "static-1.43621",
  "commerce-subscription-lib": "static-1.36553",
  "crm-actions": "static-1.6138",
  "crm-cards-data": "static-1.1285",
  "crm-cards-sdk": "static-1.43024",
  "customer-data-properties-shared-msw-handlers": "static-1.8880",
  "customer-data-tracking": "static-1.6715",
  "calling-global-api": "static-1.63793",
  "calling-internal-common": "static-1.31128",
  "calling-lifecycle-internal": "static-1.65175",
  "calling-lifecycle-messages": "static-1.57469",
  "commerce-products-lib": "static-1.8949",
  "conditional-properties-service-client": "static-1.3655",
  "crm-links": "static-1.6098",
  "external-options-client-types": "static-1.4015",
  "google-libphonenumber": "static-1.34",
  "hs-entities": "static-1.513",
  "inbounddb-objects-service-types": "static-1.4079",
  "meetings-icalendar-utils-lib": "static-1.464",
  "multi-currency-client-types": "static-1.3548",
  "object-builder-ui-client": "static-1.48112",
  "pipeline-validation-client-types": "static-1.3821",
  "property-value-citations": "static-1.1478",
  "pulse": "static-1.349",
  "smart-property-lib": "static-1.6065",
  "tiered-pricing": "static-1.875",
  "ui-addon-form-validation": "static-1.10826",
  "crm-pipelines-api-client-types": "static-1.3997",
  "react-dnd-compat": "static-1.4453",
  "react-immutable-render-mixin": "static-1.9",
  "growth-data-modal": "static-1.5191",
  "growth-onboarding-confetti": "static-1.2905",
  "growth-onboarding-next-action-utils": "static-1.1382",
  "onboarding-tours-utils": "static-1.375",
  "ui-shepherd-tracker": "static-1.7360",
  "academy-service-client": "static-1.3513",
  "final-form": "static-1.66",
  "zustand": "static-1.51",
  "ui-coaching-tips": "static-1.28034",
  "redux-actions": "static-3.7",
  "ui-addon-opt": "static-4.8218",
  "video-components-external": "static-1.10669",
  "video-data-lib": "static-1.34327",
  "emoji-mart": "static-3.4",
  "knowledge-content-types": "static-1.8399",
  "payment-link-components": "static-1.23030",
  "ui-addon-emoji-picker": "static-1.9720",
  "EmailSignatureEditor": "static-1.23979",
  "viral-links-lib": "static-1.6870",
  "data-token-picker": "static-1.16100",
  "FileManagerLib": "static-1.38636",
  "react-flip-move": "static-1.66",
  "timezone-utils": "static-2.5077",
  "getting-started-shared-tasks-store": "static-1.17096",
  "campaign-roi-lib": "static-1.8383",
  "diff-match-patch": "static-1.7",
  "browser-eslint": "static-2.57",
  "edison-service-client-types": "static-1.225",
  "eligibility-engine-service-types": "static-1.3014",
  "crm_data": "static-4.91351",
  "customer-data-sidebar": "static-2.45506",
  "enrichment-properties-lib": "static-1.15183",
  "commerce-billing-lib": "static-1.18587",
  "commerce-shared-components-lib": "static-1.18036",
  "commerce-tools-ui-lib": "static-1.9878",
  "crm-fe-perf": "static-1.22737",
  "calling-error-reporting": "static-1.31134",
  "shared-worker-versioning": "static-1.10872",
  "calling-usage-tracker": "static-1.6374",
  "voice-sms-access-library": "static-1.344",
  "commerce-permissions": "static-1.591",
  "products-iframe-lib": "static-1.7419",
  "products-ui-components-shared-msw-handlers": "static-1.9935",
  "directed-graph": "static-1.772",
  "event-emitter": "static-1.779",
  "breeze-intelligence-kit": "static-1.5369",
  "framework-data-schema-resolvers-shared-msw-handlers": "static-1.9636",
  "policy-lib": "static-1.6610",
  "react-tinymce": "static-1.54712",
  "reference-resolvers-lite-shared-msw-handlers": "static-1.9699",
  "tinymce": "static-5.11",
  "tinymce-config": "static-2.53838",
  "tinymce-plugins": "static-1.56952",
  "tinymce-themes": "static-1.55808",
  "growth-onboarding-next-action-components": "static-1.1410",
  "user-context-client": "static-1.4477",
  "growth-onboarding-feedback-components": "static-1.6414",
  "content-media-composition-data-lib": "static-1.11572",
  "content-media-compositions": "static-2.15579",
  "media-bridge-lib": "static-1.18622",
  "commerce-tours-lib": "static-1.5765",
  "growth-onboarding-reliability": "static-1.4919",
  "sales-checkout-service-client": "static-1.3499",
  "draft-convert": "static-2.68",
  "draft-extend": "static-3.71",
  "draft-js": "static-5.73",
  "draft-plugins": "static-2.21364",
  "sales-email-signature-service-client": "static-1.3675",
  "audio-components": "static-1.5660",
  "FileManagerCore": "static-1.38495",
  "FileManagerImages": "static-1.36147",
  "video-components": "static-1.12672",
  "crm_universal": "static-1.21717",
  "customer-data-email": "static-1.17726",
  "card-payment-highlight-lib": "static-1.36605",
  "card-subscription-highlight-lib": "static-1.38976",
  "commerce-contract-lib": "static-1.11321",
  "customer-data-content": "static-1.26930",
  "invoices-highlight-card-lib": "static-1.54138",
  "orders-highlight-card-lib": "static-1.20950",
  "products-highlight-card-lib": "static-1.17233",
  "project-storage": "static-1.4566",
  "quotes-highlight-card-lib": "static-1.71316",
  "crm-source-interpretation-lib": "static-1.5162",
  "utility-belt": "static-1.2372",
  "customer-data-associations": "static-1.7169",
  "framework-data-table": "static-2.11493",
  "payments-enrollment-embed-lib": "static-1.22115",
  "customer-data-rte": "static-1.32524",
  "cv-backend-services": "static-1.1514",
  "growth-onboarding-empty-states": "static-1.5414",
  "InboxConnectUtils": "static-4.14309",
  "payments-post-enroll-local-storage-lib": "static-1.4947",
  "qrcode-generator": "static-1.65",
  "quotes-client-types": "static-1.37405",
  "calling-orchestration-schema": "static-1.35121",
  "sales-views-client-types": "static-1.4119",
  "hub-http-contrib": "static-1.2876",
  "interframe": "static-3.4617",
  "tinymce-data": "static-1.39923",
  "ui-addon-sales-email": "static-1.5047",
  "layout-dnd-components": "static-1.12097",
  "layout-dnd-utils": "static-1.11072",
  "ui-brand-identity-lib": "static-1.14098",
  "NamespacedHubStyle": "static-2.8928",
  "hls.js": "static-1.35",
  "js-cookie": "static-1.18",
  "cropperjs": "static-1.10",
  "urlinator": "static-1.4364",
  "video-embed": "static-1.35161",
  "social-insights-client-types": "static-1.21455",
  "sequences-lib": "static-1.7739",
  "ui-gdpr-components": "static-1.10180",
  "products-ui-components": "static-1.39468",
  "quotes-ui-lib": "static-1.80036",
  "SalesContentIndexUI": "static-3.8947",
  "accounting-integrations-ui-components": "static-1.6777",
  "invoices-ui-lib": "static-1.54154",
  "commerce-products-api": "static-1.2001",
  "SafeStorage": "static-1.4235",
  "invoices-iframe-lib": "static-1.56212",
  "quotes-modal-lib": "static-1.101993",
  "deal-intel-decorators": "static-1.1376",
  "tanstack-virtual": "static-1.26",
  "stripe-embedded-components": "static-1.7190",
  "draft-content-plugins": "static-1.27791",
  "ContentData": "static-1.67794",
  "layout-data-lib": "static-1.9397",
  "outpost": "static-1.4035",
  "sequences-client-types-lib": "static-1.7596",
  "commerce-tax-lib": "static-1.349",
  "property-description-translator": "static-1.3688",
  "FireAlarmUi": "static-1.4364",
  "sales-templates-service-types-lib": "static-1.4023",
  "commerce-analytics-service-client": "static-1.3487",
  "totals-ui-components": "static-1.23080",
  "deal-intel-utils": "static-1.1380",
  "stripe-connect-js": "static-1.65",
  "advanced-menus-core": "static-1.14865",
  "advanced-menus-lib": "static-1.11836",
  "ui-memberships-settings-lib": "static-1.33541",
  "commerce-totals-service-types": "static-1.3672",
  "seamless-immutable": "static-7.6",
  "simple-menus-core": "static-1.14864",
  "simple-menus-lib": "static-1.16381"
},
  depPathPrefixes: {
  "marketplace-storefront-public-ui": "/marketplace-storefront-public-ui/static-1.11658",
  "apollo-dlb": "/apollo-dlb/static-3.80",
  "client-types": "/client-types/static-1.450",
  "dashboard-client-types": "/dashboard-client-types/static-1.254",
  "data-fetching-client": "/data-fetching-client/static-1.9510",
  "foundations-components": "/foundations-components/static-1-jhardy-popover-allow-cross-axis-shift.11",
  "foundations-components-legacy": "/foundations-components-legacy/static-1-jhardy-popover-allow-cross-axis-shift.11",
  "foundations-theming": "/foundations-theming/static-1.4243",
  "googlemaps-react-wrapper": "/googlemaps-react-wrapper/static-1.3",
  "graphql": "/graphql/static-1.78",
  "head-dlb": "/head-dlb/static-1.4841",
  "hs-test-utils": "/hs-test-utils/static-1.7838",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.9553",
  "hubspot-dlb": "/hubspot-dlb/static-2.1806",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.3957",
  "HubStyleTokens": "/HubStyleTokens/static-2.11273",
  "I18n": "/I18n/static-7.1580",
  "jasmine-runner": "/jasmine-runner/static-1.6303",
  "marketplace-storefront-base": "/marketplace-storefront-base/static-1.11718",
  "quartz": "/quartz/static-1.6776",
  "react-dlb": "/react-dlb/static-1.73",
  "react-rhumb": "/react-rhumb/static-1.16483",
  "react-router-dom": "/react-router-dom/static-5.26",
  "reactive-variable-buffer-atom": "/reactive-variable-buffer-atom/static-1.2696",
  "reporting-testing-lib": "/reporting-testing-lib/static-1.8595",
  "settings-ui-lib": "/settings-ui-lib/static-1.12356",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.180",
  "signup-ui-core": "/signup-ui-core/static-1.10391",
  "source-map": "/source-map/static-1.4",
  "trellis-ecosystem": "/trellis-ecosystem/static-1.6794",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.10977",
  "ui-addon-react-router-dom": "/ui-addon-react-router-dom/static-1.9378",
  "unified-auth": "/unified-auth/static-1.260",
  "unified-auth-core-lib": "/unified-auth-core-lib/static-1.541",
  "usage-tracker": "/usage-tracker/static-1.7168",
  "usage-tracker-core": "/usage-tracker-core/static-1.7018",
  "customer-data-property-utils": "/customer-data-property-utils/static-1.7912",
  "history": "/history/static-4.47",
  "hub-http": "/hub-http/static-1.6051",
  "integrations-lib": "/integrations-lib/static-1.15535",
  "marketplace-ui-common": "/marketplace-ui-common/static-1.19043",
  "property-management-iframe": "/property-management-iframe/static-1.12468",
  "quartz-config": "/quartz-config/static-1.554",
  "quartz-core": "/quartz-core/static-1.5995",
  "quartz-routing": "/quartz-routing/static-1.206",
  "quick-fetch": "/quick-fetch/static-1.3769",
  "react": "/react/static-7.180",
  "rpc-client-utils": "/rpc-client-utils/static-1.4468",
  "ts-schema": "/ts-schema/static-1.3937",
  "ui-universal-auth": "/ui-universal-auth/static-1.8746",
  "UIComponents": "/UIComponents/static-3.8220",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.79",
  "enviro": "/enviro/static-4.405",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5387",
  "PortalIdParser": "/PortalIdParser/static-2.367",
  "raven": "/raven/static-3.5725",
  "raven-hubspot": "/raven-hubspot/static-1.6032",
  "classnames": "/classnames/static-2.10",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "immutable": "/immutable/static-2.19",
  "metrics-js": "/metrics-js/static-1.9436",
  "react-redux": "/react-redux/static-7.67",
  "redux": "/redux/static-4.16",
  "styled-components": "/styled-components/static-2.85",
  "bend-plugin-trellis-migration": "/bend-plugin-trellis-migration/static-1.3260",
  "moment": "/moment/static-3.26",
  "react-dom": "/react-dom/static-7.85",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.3053",
  "quartz-webpack": "/quartz-webpack/static-1.3000",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1-jhardy-popover-allow-cross-axis-shift.11",
  "floating-ui": "/floating-ui/static-1.52",
  "foundations-assets": "/foundations-assets/static-1.4670",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.1959",
  "framer-motion": "/framer-motion/static-1.68",
  "hs-story-utils": "/hs-story-utils/static-1.9259",
  "react-aria": "/react-aria/static-1.62",
  "react-select-plus": "/react-select-plus/static-1.65",
  "react-utils": "/react-utils/static-2.5206",
  "react-virtualized": "/react-virtualized/static-2.95",
  "StyleGuideUI": "/StyleGuideUI/static-3.484",
  "tanstack-table": "/tanstack-table/static-1.51",
  "trellis-assets": "/trellis-assets/static-1.1304",
  "ui-fonts": "/ui-fonts/static-1.535",
  "ui-images": "/ui-images/static-2.1105",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.2726",
  "foundations-theming-base": "/foundations-theming-base/static-1.3228",
  "stylex": "/stylex/static-1.28",
  "HeadJS": "/HeadJS/static-2.718",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.2949",
  "msw": "/msw/static-1.39",
  "testing-library": "/testing-library/static-1.148",
  "webpack-env": "/webpack-env/static-1.54",
  "i18n-data": "/i18n-data/static-1.217",
  "moment-timezone": "/moment-timezone/static-5.79",
  "jasmine": "/jasmine/static-4.4159",
  "ai-components-ui-library": "/ai-components-ui-library/static-1.8440",
  "ai-rendering-library": "/ai-rendering-library/static-1.9403",
  "chirp-fetch": "/chirp-fetch/static-1.1714",
  "connections-embed-lib": "/connections-embed-lib/static-1.685",
  "copilot-toolkit": "/copilot-toolkit/static-1.10617",
  "laboratory-lib": "/laboratory-lib/static-3.6992",
  "marketplace-embed": "/marketplace-embed/static-1.21560",
  "marketplace-ui-details": "/marketplace-ui-details/static-1.8939",
  "marketplace-ui-reviews": "/marketplace-ui-reviews/static-1.18999",
  "marketplace-ui-tracking": "/marketplace-ui-tracking/static-1.13214",
  "sanitize-text": "/sanitize-text/static-1.7978",
  "ui-addon-video-player": "/ui-addon-video-player/static-1.8529",
  "usage-tracker-multi": "/usage-tracker-multi/static-1.5582",
  "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.4854",
  "wootric-nps": "/wootric-nps/static-1.6817",
  "apollo-link-hub-http": "/apollo-link-hub-http/static-2.4484",
  "immer": "/immer/static-1.33",
  "immerable": "/immerable/static-1.3987",
  "highcharts": "/highcharts/static-8.100",
  "hs-lodash": "/hs-lodash/static-4.45",
  "reporting-client-types": "/reporting-client-types/static-1.2387",
  "reporting-data": "/reporting-data/static-1.66662",
  "cssUtils": "/cssUtils/static-1.744",
  "flux-actions": "/flux-actions/static-1.311",
  "HubStyle": "/HubStyle/static-2.11581",
  "PatternValidationJS": "/PatternValidationJS/static-1.437",
  "react-colorpicker": "/react-colorpicker/static-2.10044",
  "react-dnd": "/react-dnd/static-5.6",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-5.6",
  "redux-observable": "/redux-observable/static-1.11",
  "ReduxMessenger": "/ReduxMessenger/static-2.10206",
  "rxjs": "/rxjs/static-5.10",
  "underscore": "/underscore/static-1.8",
  "usage-tracker-container": "/usage-tracker-container/static-1.7158",
  "icons": "/icons/static-2.625",
  "marketplace-ui-apps-core": "/marketplace-ui-apps-core/static-1.17576",
  "storybook-react": "/storybook-react/static-1.29",
  "trellis-story-utils": "/trellis-story-utils/static-1.4353",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1-jhardy-popover-allow-cross-axis-shift.11",
  "quartz-i18n": "/quartz-i18n/static-1.451",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "fsm": "/fsm/static-1.3563",
  "customer-data-objects": "/customer-data-objects/static-1.7480",
  "property-translator": "/property-translator/static-1.5242",
  "frontend-preferences-client": "/frontend-preferences-client/static-1.7757",
  "hs-promise-utils": "/hs-promise-utils/static-1.5426",
  "hubspot-apollo-client": "/hubspot-apollo-client/static-1.4712",
  "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.12950",
  "integrations-tracking-lib": "/integrations-tracking-lib/static-1.5421",
  "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.7620",
  "reselect": "/reselect/static-2.16",
  "sanitize": "/sanitize/static-1.4307",
  "superstore": "/superstore/static-1.4603",
  "ui-shepherd-react": "/ui-shepherd-react/static-3.9979",
  "ai-settings-ui-library": "/ai-settings-ui-library/static-1.7550",
  "hub-http-janus": "/hub-http-janus/static-1.803",
  "hubspotter-http": "/hubspotter-http/static-1.4510",
  "immutable-less": "/immutable-less/static-1.4487",
  "marketplace-ui-client-types": "/marketplace-ui-client-types/static-1.16450",
  "nav-meta": "/nav-meta/static-1.29020",
  "react-window": "/react-window/static-1.13",
  "self-service-api": "/self-service-api/static-1.10073",
  "ui-addon-upgrades": "/ui-addon-upgrades/static-9.17702",
  "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.3705",
  "property-management-common": "/property-management-common/static-1.4755",
  "ui-addon-iframeable": "/ui-addon-iframeable/static-1.8879",
  "dispatcher": "/dispatcher/static-1.132",
  "general-store": "/general-store/static-6.20",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.491",
  "module-federation": "/module-federation/static-1.19",
  "quartz-auth": "/quartz-auth/static-1.451",
  "quartz-head": "/quartz-head/static-1.441",
  "quartz-test": "/quartz-test/static-1.451",
  "quartz-tracking": "/quartz-tracking/static-1.155",
  "csstype": "/csstype/static-1.50",
  "bender-build-tools": "/bender-build-tools/static-1.2982",
  "autolinker": "/autolinker/static-3.11",
  "chatspot-core": "/chatspot-core/static-1.20470",
  "ContentUtils": "/ContentUtils/static-1.67719",
  "sassPrefix": "/sassPrefix/static-1.152",
  "avatar-components": "/avatar-components/static-1.2322",
  "customer-data-filters-ui": "/customer-data-filters-ui/static-1.39023",
  "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.12843",
  "customer-data-reference-ui-components": "/customer-data-reference-ui-components/static-1.12979",
  "embedded-academy-lib": "/embedded-academy-lib/static-1.13662",
  "ExportDialog": "/ExportDialog/static-6.10220",
  "highlight.js": "/highlight.js/static-1.75",
  "markdown-it": "/markdown-it/static-1.6",
  "reporting-action-components": "/reporting-action-components/static-1.40739",
  "reporting-snowflake": "/reporting-snowflake/static-1.55280",
  "reporting-ui-components": "/reporting-ui-components/static-2.63933",
  "reporting-visualizations": "/reporting-visualizations/static-1.58738",
  "ui-addon-teams": "/ui-addon-teams/static-1.21283",
  "magpie-lib": "/magpie-lib/static-1.5426",
  "magpie-types": "/magpie-types/static-1.4886",
  "simple-logging-lib": "/simple-logging-lib/static-1.2883",
  "navigation-components": "/navigation-components/static-1.17383",
  "ai-studio-lib": "/ai-studio-lib/static-1.11088",
  "developer-experience-shared-components": "/developer-experience-shared-components/static-1.10325",
  "transmute": "/transmute/static-2.85",
  "ui-addon-integrations-directory-panel": "/ui-addon-integrations-directory-panel/static-2.7824",
  "ui-tool-access": "/ui-tool-access/static-1.9977",
  "usage-based-billing-components-lib": "/usage-based-billing-components-lib/static-1.8097",
  "usage-tracker-anonymous": "/usage-tracker-anonymous/static-1.5585",
  "usage-tracker-public": "/usage-tracker-public/static-1.6979",
  "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.56",
  "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3452",
  "persist-promise": "/persist-promise/static-1.3540",
  "reference-resolvers": "/reference-resolvers/static-1.7995",
  "ui-extensibility-client-types": "/ui-extensibility-client-types/static-1.3776",
  "hubspot-apollo-cache": "/hubspot-apollo-cache/static-1.171",
  "universal-page-editor-lib": "/universal-page-editor-lib/static-1.2831",
  "redux-toolkit": "/redux-toolkit/static-1.7",
  "simple-data-table": "/simple-data-table/static-1.2275",
  "merchandise-lib": "/merchandise-lib/static-1.260",
  "atom": "/atom/static-1.4902",
  "purchase-motions-components": "/purchase-motions-components/static-1.5523",
  "salesImages": "/salesImages/static-1.521",
  "batch-promise": "/batch-promise/static-1.1383",
  "crm-component-utils": "/crm-component-utils/static-1.38560",
  "crm-properties-common-lib": "/crm-properties-common-lib/static-1.5705",
  "customer-data-properties": "/customer-data-properties/static-1.50864",
  "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.6704",
  "reference-resolvers-lite": "/reference-resolvers-lite/static-1.7923",
  "navigation-messaging": "/navigation-messaging/static-1.6710",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.9551",
  "cms-field-types": "/cms-field-types/static-1.4640",
  "content-icons-ui": "/content-icons-ui/static-1.2167",
  "conversations-skeleton-state": "/conversations-skeleton-state/static-1.7081",
  "crm-message-bus": "/crm-message-bus/static-1.42466",
  "customer-data-filters-ui-msw-helpers": "/customer-data-filters-ui-msw-helpers/static-1.21458",
  "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.9657",
  "FormUrlGenerator": "/FormUrlGenerator/static-2.4557",
  "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.3864",
  "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.6609",
  "multi-account-reference-resolvers": "/multi-account-reference-resolvers/static-1.806",
  "onboarding-tours": "/onboarding-tours/static-1.16309",
  "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
  "reporting-datasets-permissions-lib": "/reporting-datasets-permissions-lib/static-1.13158",
  "academy-common-lib": "/academy-common-lib/static-1.13122",
  "content-assistance-lib": "/content-assistance-lib/static-1.7496",
  "dashboard-lib": "/dashboard-lib/static-1.80763",
  "file-manager-components": "/file-manager-components/static-1.22996",
  "getting-started-shared-tasks": "/getting-started-shared-tasks/static-1.17978",
  "hubspot-prosemirror": "/hubspot-prosemirror/static-1.17695",
  "hubspot-prosemirror-plugins": "/hubspot-prosemirror-plugins/static-1.17687",
  "prosemirror": "/prosemirror/static-1.13",
  "rich-text-lib": "/rich-text-lib/static-1.19527",
  "share-with-third-party-component-lib": "/share-with-third-party-component-lib/static-1.8526",
  "ui-addon-draggable": "/ui-addon-draggable/static-3.4599",
  "ui-asset-management-lib": "/ui-asset-management-lib/static-1.10751",
  "ui-business-units-lib": "/ui-business-units-lib/static-1.8861",
  "user-context": "/user-context/static-1.4932",
  "growth-payments-core": "/growth-payments-core/static-1.24823",
  "reporting-plugins": "/reporting-plugins/static-1.10022",
  "reporting-reports": "/reporting-reports/static-1.66340",
  "idb-keyval": "/idb-keyval/static-1.40",
  "reactive-lib": "/reactive-lib/static-1.558",
  "codemirror": "/codemirror/static-5.91",
  "feedback-loader": "/feedback-loader/static-1.28928",
  "react-codemirror": "/react-codemirror/static-1.10459",
  "apps-service-types": "/apps-service-types/static-1.3709",
  "oauth-service-types": "/oauth-service-types/static-1.4080",
  "onboarding-scopes": "/onboarding-scopes/static-1.6296",
  "onboarding-tours-client": "/onboarding-tours-client/static-1.4523",
  "platform-infra-nav-components": "/platform-infra-nav-components/static-1.7523",
  "subscription-experience-data-types": "/subscription-experience-data-types/static-1.14623",
  "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3475",
  "location-customization-utils-lib": "/location-customization-utils-lib/static-1.8667",
  "redux-thunk": "/redux-thunk/static-2.43",
  "growth-monetization-service-types": "/growth-monetization-service-types/static-1.4332",
  "nav-client-types": "/nav-client-types/static-1.2189",
  "purchase-motions-api": "/purchase-motions-api/static-1.5526",
  "signup-constants": "/signup-constants/static-1.18489",
  "signup-ui-url-generator": "/signup-ui-url-generator/static-2.7867",
  "trials-service-types": "/trials-service-types/static-1.3733",
  "card-properties-lib": "/card-properties-lib/static-1.43621",
  "commerce-subscription-lib": "/commerce-subscription-lib/static-1.36553",
  "crm-actions": "/crm-actions/static-1.6138",
  "crm-cards-data": "/crm-cards-data/static-1.1285",
  "crm-cards-sdk": "/crm-cards-sdk/static-1.43024",
  "customer-data-properties-shared-msw-handlers": "/customer-data-properties-shared-msw-handlers/static-1.8880",
  "customer-data-tracking": "/customer-data-tracking/static-1.6715",
  "calling-global-api": "/calling-global-api/static-1.63793",
  "calling-internal-common": "/calling-internal-common/static-1.31128",
  "calling-lifecycle-internal": "/calling-lifecycle-internal/static-1.65175",
  "calling-lifecycle-messages": "/calling-lifecycle-messages/static-1.57469",
  "commerce-products-lib": "/commerce-products-lib/static-1.8949",
  "conditional-properties-service-client": "/conditional-properties-service-client/static-1.3655",
  "crm-links": "/crm-links/static-1.6098",
  "external-options-client-types": "/external-options-client-types/static-1.4015",
  "google-libphonenumber": "/google-libphonenumber/static-1.34",
  "hs-entities": "/hs-entities/static-1.513",
  "inbounddb-objects-service-types": "/inbounddb-objects-service-types/static-1.4079",
  "meetings-icalendar-utils-lib": "/meetings-icalendar-utils-lib/static-1.464",
  "multi-currency-client-types": "/multi-currency-client-types/static-1.3548",
  "object-builder-ui-client": "/object-builder-ui-client/static-1.48112",
  "pipeline-validation-client-types": "/pipeline-validation-client-types/static-1.3821",
  "property-value-citations": "/property-value-citations/static-1.1478",
  "pulse": "/pulse/static-1.349",
  "smart-property-lib": "/smart-property-lib/static-1.6065",
  "tiered-pricing": "/tiered-pricing/static-1.875",
  "ui-addon-form-validation": "/ui-addon-form-validation/static-1.10826",
  "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.3997",
  "react-dnd-compat": "/react-dnd-compat/static-1.4453",
  "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
  "growth-data-modal": "/growth-data-modal/static-1.5191",
  "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.2905",
  "growth-onboarding-next-action-utils": "/growth-onboarding-next-action-utils/static-1.1382",
  "onboarding-tours-utils": "/onboarding-tours-utils/static-1.375",
  "ui-shepherd-tracker": "/ui-shepherd-tracker/static-1.7360",
  "academy-service-client": "/academy-service-client/static-1.3513",
  "final-form": "/final-form/static-1.66",
  "zustand": "/zustand/static-1.51",
  "ui-coaching-tips": "/ui-coaching-tips/static-1.28034",
  "redux-actions": "/redux-actions/static-3.7",
  "ui-addon-opt": "/ui-addon-opt/static-4.8218",
  "video-components-external": "/video-components-external/static-1.10669",
  "video-data-lib": "/video-data-lib/static-1.34327",
  "emoji-mart": "/emoji-mart/static-3.4",
  "knowledge-content-types": "/knowledge-content-types/static-1.8399",
  "payment-link-components": "/payment-link-components/static-1.23030",
  "ui-addon-emoji-picker": "/ui-addon-emoji-picker/static-1.9720",
  "EmailSignatureEditor": "/EmailSignatureEditor/static-1.23979",
  "viral-links-lib": "/viral-links-lib/static-1.6870",
  "data-token-picker": "/data-token-picker/static-1.16100",
  "FileManagerLib": "/FileManagerLib/static-1.38636",
  "react-flip-move": "/react-flip-move/static-1.66",
  "timezone-utils": "/timezone-utils/static-2.5077",
  "getting-started-shared-tasks-store": "/getting-started-shared-tasks-store/static-1.17096",
  "campaign-roi-lib": "/campaign-roi-lib/static-1.8383",
  "diff-match-patch": "/diff-match-patch/static-1.7",
  "browser-eslint": "/browser-eslint/static-2.57",
  "edison-service-client-types": "/edison-service-client-types/static-1.225",
  "eligibility-engine-service-types": "/eligibility-engine-service-types/static-1.3014",
  "crm_data": "/crm_data/static-4.91351",
  "customer-data-sidebar": "/customer-data-sidebar/static-2.45506",
  "enrichment-properties-lib": "/enrichment-properties-lib/static-1.15183",
  "commerce-billing-lib": "/commerce-billing-lib/static-1.18587",
  "commerce-shared-components-lib": "/commerce-shared-components-lib/static-1.18036",
  "commerce-tools-ui-lib": "/commerce-tools-ui-lib/static-1.9878",
  "crm-fe-perf": "/crm-fe-perf/static-1.22737",
  "calling-error-reporting": "/calling-error-reporting/static-1.31134",
  "shared-worker-versioning": "/shared-worker-versioning/static-1.10872",
  "calling-usage-tracker": "/calling-usage-tracker/static-1.6374",
  "voice-sms-access-library": "/voice-sms-access-library/static-1.344",
  "commerce-permissions": "/commerce-permissions/static-1.591",
  "products-iframe-lib": "/products-iframe-lib/static-1.7419",
  "products-ui-components-shared-msw-handlers": "/products-ui-components-shared-msw-handlers/static-1.9935",
  "directed-graph": "/directed-graph/static-1.772",
  "event-emitter": "/event-emitter/static-1.779",
  "breeze-intelligence-kit": "/breeze-intelligence-kit/static-1.5369",
  "framework-data-schema-resolvers-shared-msw-handlers": "/framework-data-schema-resolvers-shared-msw-handlers/static-1.9636",
  "policy-lib": "/policy-lib/static-1.6610",
  "react-tinymce": "/react-tinymce/static-1.54712",
  "reference-resolvers-lite-shared-msw-handlers": "/reference-resolvers-lite-shared-msw-handlers/static-1.9699",
  "tinymce": "/tinymce/static-5.11",
  "tinymce-config": "/tinymce-config/static-2.53838",
  "tinymce-plugins": "/tinymce-plugins/static-1.56952",
  "tinymce-themes": "/tinymce-themes/static-1.55808",
  "growth-onboarding-next-action-components": "/growth-onboarding-next-action-components/static-1.1410",
  "user-context-client": "/user-context-client/static-1.4477",
  "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.6414",
  "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.11572",
  "content-media-compositions": "/content-media-compositions/static-2.15579",
  "media-bridge-lib": "/media-bridge-lib/static-1.18622",
  "commerce-tours-lib": "/commerce-tours-lib/static-1.5765",
  "growth-onboarding-reliability": "/growth-onboarding-reliability/static-1.4919",
  "sales-checkout-service-client": "/sales-checkout-service-client/static-1.3499",
  "draft-convert": "/draft-convert/static-2.68",
  "draft-extend": "/draft-extend/static-3.71",
  "draft-js": "/draft-js/static-5.73",
  "draft-plugins": "/draft-plugins/static-2.21364",
  "sales-email-signature-service-client": "/sales-email-signature-service-client/static-1.3675",
  "audio-components": "/audio-components/static-1.5660",
  "FileManagerCore": "/FileManagerCore/static-1.38495",
  "FileManagerImages": "/FileManagerImages/static-1.36147",
  "video-components": "/video-components/static-1.12672",
  "crm_universal": "/crm_universal/static-1.21717",
  "customer-data-email": "/customer-data-email/static-1.17726",
  "card-payment-highlight-lib": "/card-payment-highlight-lib/static-1.36605",
  "card-subscription-highlight-lib": "/card-subscription-highlight-lib/static-1.38976",
  "commerce-contract-lib": "/commerce-contract-lib/static-1.11321",
  "customer-data-content": "/customer-data-content/static-1.26930",
  "invoices-highlight-card-lib": "/invoices-highlight-card-lib/static-1.54138",
  "orders-highlight-card-lib": "/orders-highlight-card-lib/static-1.20950",
  "products-highlight-card-lib": "/products-highlight-card-lib/static-1.17233",
  "project-storage": "/project-storage/static-1.4566",
  "quotes-highlight-card-lib": "/quotes-highlight-card-lib/static-1.71316",
  "crm-source-interpretation-lib": "/crm-source-interpretation-lib/static-1.5162",
  "utility-belt": "/utility-belt/static-1.2372",
  "customer-data-associations": "/customer-data-associations/static-1.7169",
  "framework-data-table": "/framework-data-table/static-2.11493",
  "payments-enrollment-embed-lib": "/payments-enrollment-embed-lib/static-1.22115",
  "customer-data-rte": "/customer-data-rte/static-1.32524",
  "cv-backend-services": "/cv-backend-services/static-1.1514",
  "growth-onboarding-empty-states": "/growth-onboarding-empty-states/static-1.5414",
  "InboxConnectUtils": "/InboxConnectUtils/static-4.14309",
  "payments-post-enroll-local-storage-lib": "/payments-post-enroll-local-storage-lib/static-1.4947",
  "qrcode-generator": "/qrcode-generator/static-1.65",
  "quotes-client-types": "/quotes-client-types/static-1.37405",
  "calling-orchestration-schema": "/calling-orchestration-schema/static-1.35121",
  "sales-views-client-types": "/sales-views-client-types/static-1.4119",
  "hub-http-contrib": "/hub-http-contrib/static-1.2876",
  "interframe": "/interframe/static-3.4617",
  "tinymce-data": "/tinymce-data/static-1.39923",
  "ui-addon-sales-email": "/ui-addon-sales-email/static-1.5047",
  "layout-dnd-components": "/layout-dnd-components/static-1.12097",
  "layout-dnd-utils": "/layout-dnd-utils/static-1.11072",
  "ui-brand-identity-lib": "/ui-brand-identity-lib/static-1.14098",
  "NamespacedHubStyle": "/NamespacedHubStyle/static-2.8928",
  "hls.js": "/hls.js/static-1.35",
  "js-cookie": "/js-cookie/static-1.18",
  "cropperjs": "/cropperjs/static-1.10",
  "urlinator": "/urlinator/static-1.4364",
  "video-embed": "/video-embed/static-1.35161",
  "social-insights-client-types": "/social-insights-client-types/static-1.21455",
  "sequences-lib": "/sequences-lib/static-1.7739",
  "ui-gdpr-components": "/ui-gdpr-components/static-1.10180",
  "products-ui-components": "/products-ui-components/static-1.39468",
  "quotes-ui-lib": "/quotes-ui-lib/static-1.80036",
  "SalesContentIndexUI": "/SalesContentIndexUI/static-3.8947",
  "accounting-integrations-ui-components": "/accounting-integrations-ui-components/static-1.6777",
  "invoices-ui-lib": "/invoices-ui-lib/static-1.54154",
  "commerce-products-api": "/commerce-products-api/static-1.2001",
  "SafeStorage": "/SafeStorage/static-1.4235",
  "invoices-iframe-lib": "/invoices-iframe-lib/static-1.56212",
  "quotes-modal-lib": "/quotes-modal-lib/static-1.101993",
  "deal-intel-decorators": "/deal-intel-decorators/static-1.1376",
  "tanstack-virtual": "/tanstack-virtual/static-1.26",
  "stripe-embedded-components": "/stripe-embedded-components/static-1.7190",
  "draft-content-plugins": "/draft-content-plugins/static-1.27791",
  "ContentData": "/ContentData/static-1.67794",
  "layout-data-lib": "/layout-data-lib/static-1.9397",
  "outpost": "/outpost/static-1.4035",
  "sequences-client-types-lib": "/sequences-client-types-lib/static-1.7596",
  "commerce-tax-lib": "/commerce-tax-lib/static-1.349",
  "property-description-translator": "/property-description-translator/static-1.3688",
  "FireAlarmUi": "/FireAlarmUi/static-1.4364",
  "sales-templates-service-types-lib": "/sales-templates-service-types-lib/static-1.4023",
  "commerce-analytics-service-client": "/commerce-analytics-service-client/static-1.3487",
  "totals-ui-components": "/totals-ui-components/static-1.23080",
  "deal-intel-utils": "/deal-intel-utils/static-1.1380",
  "stripe-connect-js": "/stripe-connect-js/static-1.65",
  "advanced-menus-core": "/advanced-menus-core/static-1.14865",
  "advanced-menus-lib": "/advanced-menus-lib/static-1.11836",
  "ui-memberships-settings-lib": "/ui-memberships-settings-lib/static-1.33541",
  "commerce-totals-service-types": "/commerce-totals-service-types/static-1.3672",
  "seamless-immutable": "/seamless-immutable/static-7.6",
  "simple-menus-core": "/simple-menus-core/static-1.14864",
  "simple-menus-lib": "/simple-menus-lib/static-1.16381"
}
};
